// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mechanic_mechanic__column__naa7A {
    position: sticky;
    flex: 0 0 var(--schedule-employee-column-width);
    width: var(--schedule-employee-column-width);
    min-width: var(--schedule-employee-column-width);
    left: 0;
    z-index: 10;
    background: #fff;
}

.mechanic_weekday_month_year__m\\+s76 {
    font-weight: bold;
    background: #ecd2b5;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 5;
}

.mechanic_day_cell__-N2TP {
    border: 1px solid rgba(0, 0, 0, 0.65);
    box-sizing: border-box;
    padding: 0 4px;
    height: var(--schedule-row-height);
    min-height: var(--schedule-row-height);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: pre-wrap;
}

.mechanic_mechanic_cell__\\+7sRH {
    border: 1px solid rgba(0, 0, 0, 0.65);
    box-sizing: border-box;
    padding: 0 4px;
    height: var(--schedule-row-height);
    min-height: var(--schedule-row-height);
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.mechanic_mechanic_group_separator__EYKbT {
    position: relative;
}

.mechanic_mechanic_group_separator__EYKbT::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: #ff0000;
    z-index: 20;
    pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/mechanic-data/mechanic.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,+CAA+C;IAC/C,4CAA4C;IAC5C,gDAAgD;IAChD,OAAO;IACP,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,OAAO;IACP,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,sBAAsB;IACtB,cAAc;IACd,kCAAkC;IAClC,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,sBAAsB;IACtB,cAAc;IACd,kCAAkC;IAClC,sCAAsC;IACtC,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,oBAAoB;AACxB","sourcesContent":[".mechanic__column {\n    position: sticky;\n    flex: 0 0 var(--schedule-employee-column-width);\n    width: var(--schedule-employee-column-width);\n    min-width: var(--schedule-employee-column-width);\n    left: 0;\n    z-index: 10;\n    background: #fff;\n}\n\n.weekday_month_year {\n    font-weight: bold;\n    background: #ecd2b5;\n    position: sticky;\n    top: 0;\n    left: 0;\n    z-index: 5;\n}\n\n.day_cell {\n    border: 1px solid rgba(0, 0, 0, 0.65);\n    box-sizing: border-box;\n    padding: 0 4px;\n    height: var(--schedule-row-height);\n    min-height: var(--schedule-row-height);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    white-space: pre-wrap;\n}\n\n.mechanic_cell {\n    border: 1px solid rgba(0, 0, 0, 0.65);\n    box-sizing: border-box;\n    padding: 0 4px;\n    height: var(--schedule-row-height);\n    min-height: var(--schedule-row-height);\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.mechanic_group_separator {\n    position: relative;\n}\n\n.mechanic_group_separator::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 4px;\n    background: #ff0000;\n    z-index: 20;\n    pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mechanic__column": `mechanic_mechanic__column__naa7A`,
	"weekday_month_year": `mechanic_weekday_month_year__m+s76`,
	"day_cell": `mechanic_day_cell__-N2TP`,
	"mechanic_cell": `mechanic_mechanic_cell__+7sRH`,
	"mechanic_group_separator": `mechanic_mechanic_group_separator__EYKbT`
};
export default ___CSS_LOADER_EXPORT___;
